import ApplicationDetailsPage from '@/modules/dashboard-startup/ApplicationDetailsPage'
import ApplicationListPage from '@/modules/dashboard-startup/ApplicationListPage'
import ChatThreadList from '@/pages/chat/ChatThreadList'
import ChatThreadMessages from '@/pages/chat/ChatThreadMessages'
import DashboardApp from 'modules/dashboard-startup/App.vue'
import DashboardStartupList from 'modules/startup-list/StartupListPage.vue'
import DashboardStartupListFollowed from 'modules/startup-list-followed/StartupListFollowedPage.vue'
import EventDetails from '@/modules/events/EventDetails'
import EventDetailsPage from '@/modules/events/EventDetailsPage'
import EventEditor from '@/modules/events/EventEditor'
import EventListPage from '@/modules/events/EventListPage'
import FeaturedStartupsPage from '@/pages/organizations/FeaturedStartupsPage'
import InvestorFunnelPage from 'modules/investor-funnel/InvestorFunnelPage.vue'
import InvestorList from 'modules/investor-list/InvestorList.vue'
import InvestorsForStartupList from 'modules/investor-list/InvestorsForStartupList.vue'
import LinksPage from '@/modules/dashboard-startup/LinksPage'
import MyOrganization from '@/modules/dashboard-organizer/MyOrganization'
import OrganizationFunnel from '@/components/organizations/Funnel'
import OrganizationReports from '@/pages/OrganizationReports'
import OrganizerProgramDetailsPage from '@/modules/dashboard-organizer/ProgramDetailsPage'
import OrganizerProgramListPage from '@/modules/dashboard-organizer/ProgramListPage'
import ProgramEditor from '@/modules/dashboard-organizer/ProgramEditor'
import ProgramResults from '@/modules/dashboard-organizer/ProgramResults'
import Sample from './Sample/Sample.vue'
import Settings from '@/modules/dashboard-startup/Settings'
import ShortlistDetailsPage from '@/pages/shortlists/ShortlistsPage/ShortlistDetailsPage.vue'
import ShortlistsPage from '@/pages/shortlists/ShortlistsPage/ShortlistsPage.vue'
import StartupEdit from '@/modules/dashboard-startup/StartupEdit'
import StartupMarketplace from '@/pages/startup/StartupMarketplace'
import StartupProfileModal from '@/components/startups/StartupProfileModal.vue'

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardApp,
    beforeEnter: (to, from, next) => {
      // TODO: make sure user is already fetched here
      next()
    },
    children: [
      {
        path: 'startups',
        name: 'dashboardStartupList',
        component: DashboardStartupList,
      },
      {
        path: 'new-startups',
        name: 'dashboardNewStartupList',
        component: DashboardStartupList,
        props: {
          showRecent: true,
        },
      },
      {
        path: 'featured-startups',
        name: 'dashboardFeaturedStartups',
        component: FeaturedStartupsPage,
      },
      {
        path: 'funnel',
        name: 'organizationFunnel',
        component: OrganizationFunnel,
        children: [
          {
            path: 'startup/:startupId',
            name: 'organizationFunnelStartup',
            component: StartupProfileModal,
            props: true,
          },
        ],
      },
      {
        path: 'my-organization',
        name: 'dashboardMyOrganization',
        component: MyOrganization,
      },
      {
        path: 'shortlist',
        name: 'dashboardStartupListFollowed',
        component: ShortlistsPage,
      },
      {
        path: 'shortlists',
        name: 'shortlistListPage',
        component: ShortlistsPage,
      },
      {
        path: 'shortlist/:shortlistId',
        name: 'shortlistDetailsPage',
        component: ShortlistDetailsPage,
        props: true,
      },
      {
        path: 'investors',
        name: 'dashboardInvestorList',
        component: InvestorList,
      },
      {
        path: 'investors-startup',
        name: 'dashboardInvestorsForStartup',
        component: InvestorsForStartupList,
      },
      {
        path: 'investor-funnel',
        name: 'investorFunnel',
        component: InvestorFunnelPage,
        props: { editable: true },
      },
      { path: 'edit', name: 'dashboardStartupEdit', component: StartupEdit },
      { path: 'links', name: 'dashboardStartupLinks', component: LinksPage },
      {
        path: 'applications',
        name: 'dashboardApplicationList',
        component: ApplicationListPage,
      },
      {
        path: 'applications/:id',
        name: 'dashboardApplicationDetails',
        component: ApplicationDetailsPage,
      },
      {
        path: 'marketplace',
        name: 'dashboardMarketplace',
        component: StartupMarketplace,
      },
      {
        path: 'settings',
        name: 'dashboardStartupSettings',
        component: Settings,
      },
      {
        path: 'programs',
        name: 'dashboardOrganizationProgramList',
        component: OrganizerProgramListPage,
      },
      {
        path: 'program-reports',
        name: 'dashboardOrganizationReports',
        component: OrganizationReports,
      },
      {
        path: 'messages',
        name: 'chatThreadList',
        component: ChatThreadList,
        children: [
          {
            path: ':threadId',
            name: 'chatThreadMessages',
            component: ChatThreadMessages,
            props: true,
          },
        ],
      },
      {
        path: 'programs/:programId',
        component: OrganizerProgramDetailsPage,
        props: true,
        children: [
          {
            path: '',
            name: 'dashboardOrganizationProgramEdit',
            component: ProgramEditor,
            props: true,
          },
          {
            path: 'results',
            name: 'dashboardOrganizationProgramResults',
            component: ProgramResults,
            props: true,
          },
        ],
      },
      {
        path: 'showroom',
        component: { template: '<router-view/>' },
        children: [
          {
            path: '',
            name: 'eventList',
            component: EventListPage,
          },
          {
            path: ':eventId',
            component: EventDetailsPage,
            props: true,
            children: [
              {
                path: '',
                name: 'eventDetails',
                component: EventDetails,
                props: true,
              },
              {
                path: 'edit',
                name: 'eventEdit',
                component: EventEditor,
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: 'sample',
        name: 'sample',
        component: Sample,
      },
    ],
  },
]
